import { buildModelManager } from "../builder.js";
const DefaultSurveyResponseSelection = {
  __typename: true,
  id: true,
  answers: true,
  campaignId: true,
  completedAt: true,
  createdAt: true,
  email: true,
  ipAddress: true,
  metadata: true,
  questions: true,
  shopId: true,
  updatedAt: true,
  userAgent: true,
  visitorId: true
};
const modelApiIdentifier = "survey_response";
const pluralModelApiIdentifier = "survey_responses";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSurveyResponseSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSurveyResponseSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSurveyResponseSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSurveyResponseSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSurveyResponseSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSurveyResponseSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSurveyResponseSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createSurveyResponse",
    operationReturnType: "CreateSurveyResponse",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      survey_response: { required: false, type: "CreateSurveyResponseInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSurveyResponseSelection
  },
  {
    type: "action",
    operationName: "bulkCreateSurveyResponses",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateSurveyResponsesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSurveyResponseSelection
  },
  {
    type: "action",
    operationName: "updateSurveyResponse",
    operationReturnType: "UpdateSurveyResponse",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      survey_response: { required: false, type: "UpdateSurveyResponseInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSurveyResponseSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateSurveyResponses",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateSurveyResponsesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSurveyResponseSelection
  },
  {
    type: "action",
    operationName: "deleteSurveyResponse",
    operationReturnType: "DeleteSurveyResponse",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteSurveyResponses",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertSurveyResponse",
    operationReturnType: "UpsertSurveyResponse",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      survey_response: { required: false, type: "UpsertSurveyResponseInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateSurveyResponseResult": { hasReturnType: false },
      "... on UpdateSurveyResponseResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSurveyResponseSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertSurveyResponses",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertSurveyResponsesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultSurveyResponseSelection
  }
];
const SurveyResponseManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSurveyResponseSelection,
  operations
);
export {
  DefaultSurveyResponseSelection,
  SurveyResponseManager
};
//# sourceMappingURL=SurveyResponse.js.map
